import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../utils/alertMessage";
import {
  addCustomerFile,
  updateCustomerFile,
} from "../../services/customerFile";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";

export default function CustomerFileCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  let clientId = state.clientInfo.id;

  const [input, setInput] = useState({
    fileName: state.data?.fileName || "",
    fileNumber: state.data?.fileNumber || "",
    totalCost: state.data?.totalCost || "",
  });
  const [errors, setErrors] = useState({
    fileName: "",
    fileNumber: "",
    totalCost: "",
  });

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;
    if (input.fileName === "") {
      newErrors.fileName = "Please Enter FileName";
      isValid = false;
    } else {
      newErrors.fileName = "";
    }
    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state.data) {
        let data = {
          id: state.data.id,
          fileName: input.fileName,
          fileNumber: input.fileNumber,
          totalCost: input.totalCost,
          customer: state.clientInfo,
        };
        updateCustomerFile(clientId, data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                errorMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/customer-file/list", {
                  state: state.clientInfo.id,
                });
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          fileName: input.fileName,
          fileNumber: input.fileNumber,
          totalCost: input.totalCost,
          customer: state.clientInfo,
        };
        addCustomerFile(clientId, data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                errorMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/customer-file/list", {
                  state: state.clientInfo.id,
                });
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  Client File {state.data ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="fileName" className="form-label">
                        File Name
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="fileName"
                        name="fileName"
                        value={input.fileName}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            fileName: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.fileName}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="fileNumber" className="form-label">
                        File Number
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="fileNumber"
                        name="fileNumber"
                        value={input.fileNumber}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            fileNumber: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.fileNumber}</div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="totalCost" className="form-label">
                        File Amount
                      </label>
                      <InputNumber
                        inputId="horizontal"
                        value={input.totalCost}
                        id="totalCost"
                        name="totalCost"
                        style={{ width: "100%" }}
                        onValueChange={(e) =>
                          setInput({
                            ...input,
                            totalCost: e.target.value,
                          })
                        }
                        showButtons
                        buttonLayout="horizontal"
                        step={1}
                        decrementButtonClassName="p-button-danger"
                        incrementButtonClassName="p-button-success"
                        incrementButtonIcon="pi pi-plus"
                        decrementButtonIcon="pi pi-minus"
                        mode="currency"
                        currency="INR"
                        minFractionDigits={0}
                        min={0}
                        required
                      />
                      <div className="text-danger">{errors.totalCost}</div>
                    </div>
                  </div>
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-su">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
